import React, { useContext } from 'react'

import JobIcon from 'ttm-ui/dist/common/src/svg/JobIcon'
import Button from 'ttm-ui/dist/common/src/components/Button'
import AddCircleIcon from 'ttm-ui/dist/common/src/svg/AddCircleIcon'
import StarIcon from 'ttm-ui/dist/common/src/svg/StarIcon'

import capitalize from '../../utils/capitalize'
import PostContext from '../../components/Post/context'

import { getDefaultContent, getListContent, replaceContentForArchivePage } from '../post/contents'
import defaultGetMenu, { getMenuProps as defaultGetMenuProps } from '../../components/Post/menu'
import { defaultGetPageName } from '../../components/Post/utils'
import App from '../../components/App'
import PostInDrawer from '../../components/Post/PostInDrawer'

import defaultPostTypeConfig from '../post'

import Posts from '../page/Content/Posts'

import New from './New'
import Edit from './Edit'
import Activate from './Activate'
import Content from './Content'

import ListHeader from './ListHeader'
import cityIndex from './constants/cityIndex.json'
import { findCityBySlug } from './constants/utils'
import getConstants from './constants'
import { runPostTypesConfig } from '../index'

// Város → OG-kép (publikus URL, a run/public/assets/cities alatt kiszolgálva).
// ÚJ VÁROS HOZZÁADÁSA: 1) másold a képet a run/public/assets/cities mappába `<city-slug>.jpg` néven,
// 2) vegyél fel ide egy sort ugyanazzal a slug-gal. A slug az, amit a findCityBySlug ad vissza
// (cityIndex.items[].slug), pl. Vác → 'vac', Veresegyház → 'veresegyhaz'.
const cityOgImages = {
    /*balatonfured: '/assets/cities/balatonfured.jpg',
    budapest: '/assets/cities/budapest.jpg',
    vac: '/assets/cities/vac.jpg',
    veresegyhaz: '/assets/cities/veresegyhaz.jpg',*/
}

// Lista-oldali kérésben város-találat esetén visszaadja a hozzá tartozó OG-kép publikus URL-jét (dictből), különben null.
export function getCityOgImage(context) {
    try {
        const { req, res } = context
        const query = req.wappRequest.query || {}
        const params = res.wappResponse.route.params || {}
        const cityRaw =
            (typeof query.city === 'string' && query.city.trim() !== '' && query.city.trim()) ||
            (typeof params.city === 'string' && params.city.trim() !== '' && params.city.trim()) ||
            null
        if (!cityRaw) {
            return null
        }
        const matches = findCityBySlug(cityRaw, cityIndex)
        const slug = matches && matches[0] && matches[0].slug
        return (slug && cityOgImages[slug]) ? cityOgImages[slug] : null
    } catch (e) {
        return null
    }
}

export function getProfession(props) {

    const { res } = props

    const wappResponse = res.wappResponse
    const route = wappResponse.route

    const { params } = route

    if (params.professions) {
        const professions = wappResponse.store.getState('res.responses.professions')
        return professions?.items?.length ? professions.items.find((profession) => profession.slug === params.professions) : null
    }

    return null

}

export function getListPageTitle({ context, titles, name, suffix = '' }) {

    const N = capitalize(name)

    const { req, res } = context

    const profession = getProfession(context)

    const query = req.wappRequest.query || {}
    const params = res.wappResponse.route.params || {}

    const cityFromQuery =
        typeof query.city === 'string' && query.city.trim() !== ''
            ? query.city.trim()
            : null

    const cityFromPath =
        typeof params.city === 'string' && params.city.trim() !== ''
            ? params.city.trim()
            : null

    const cityRaw = cityFromQuery || cityFromPath

    const getCityAdjective = (cityName) => {
        if (titles['get' + N + 'CityTitle']) {
            return titles['get' + N + 'CityTitle']({ cityName, context })
        }
        return capitalize(cityName)
    }

    const getProfessionJobsTitle = (profession) => {
        return (
            titles[name + capitalize(profession.slug) + 'ProfessionTitle'] ||
            (titles['get' + N + 'ProfessionTitle']
                ? titles['get' + N + 'ProfessionTitle']({ profession, context })
                : '') ||
            profession.title
        ) + suffix
    }

    if (cityRaw && profession?.title) {
        const matches = findCityBySlug(cityRaw, cityIndex)
        if (matches && matches.length > 0) {
            const cityName = matches[0].name

            if (cityName) {
                const baseProfessionTitle = getProfessionJobsTitle(profession)
                return `${baseProfessionTitle}, ${capitalize(cityName)}`
            }
        }
    }

    if (cityRaw && !profession) {
        const matches = findCityBySlug(cityRaw, cityIndex)
        if (matches && matches.length > 0) {
            const cityName = matches[0].name
            const cityAdj = getCityAdjective(cityName)

            if (cityAdj) {
                let title

                if (titles['get' + N + 'CityJobsTitle']) {
                    title = titles['get' + N + 'CityJobsTitle']({
                        cityAdj,
                        cityName,
                        context
                    }) + suffix
                } else {
                    title = `${cityAdj}`
                }

                return title
            }
        }
    }

    if (profession?.title) {
        return getProfessionJobsTitle(profession)
    }

}

function getListPageDescription({ context, titles, name }) {

    const N = capitalize(name)
    const ns = (name.endsWith('y')) ? name.slice(0, -1) + 'ies' : name + 's'
    const Ns = capitalize(ns)

    const { req, res } = context

    const query = req.wappRequest.query || {}
    const params = res.wappResponse.route.params || {}

    const cityFromQuery =
        typeof query.city === 'string' && query.city.trim() !== ''
            ? query.city.trim()
            : null

    const cityFromPath =
        typeof params.city === 'string' && params.city.trim() !== ''
            ? params.city.trim()
            : null

    const cityRaw = cityFromQuery || cityFromPath
    const matches = cityRaw ? findCityBySlug(cityRaw, cityIndex) : null

    let cityName = ''
    if (matches && matches.length > 0) {
        cityName = matches[0].name
    }

    let cityAdj = ''
    const cityTitleFn = titles['get' + N + 'CityTitle']
    if (typeof cityTitleFn === 'function') {
        cityAdj = cityTitleFn({ cityName, context })
    }

    const profession = getProfession(context)

    const getProfessionJobsTitle = (profession) => {
        if (!profession?.title) {
            return ''
        }
        return (
            titles[ns + capitalize(profession.slug) + 'ProfessionDescription'] ||
            (titles['get' + Ns + 'ProfessionDescription']
                ? titles['get' + Ns + 'ProfessionDescription']({ profession, context })
                : '') ||
            profession.title
        )
    }

    if (typeof titles['get' + Ns + 'Description'] === 'function') {
        return titles['get' + Ns + 'Description']({
            cityAdj,
            professionAdj: getProfessionJobsTitle(profession)
        })
    }

    return null

}

function getPostTitle({ context, getPost, getTitle, postContent, titles }) {

    const { res } = context
    const post = getPost(res)

    const title = [post?.subtitle, post?.title].filter((t) => t).join(' | ')

    if (title) {
        const nearbyText = (post?._nearestBigCity && titles?.jobNearestBigCity) ? titles.jobNearestBigCity({ city: post._nearestBigCity }) : ''
        const fullTitle = title + nearbyText
        return `${getTitle ? getTitle({ ...context, title: fullTitle }) : fullTitle}`
    }

    const defaultTitleFunction = typeof context.defaultTitle === 'function' || typeof context.defaultTitle === 'string' ? context.defaultTitle : postContent.title
    return typeof defaultTitleFunction === 'function' ? defaultTitleFunction(context) : defaultTitleFunction

}

function getPostDescription({ context, getPost, postContent, titles }) {
    const { res } = context

    const post = getPost(res)

    if (post?.description) {
        const nearbyText = (post?._nearestBigCity && titles?.jobNearestBigCityDesc) ? titles.jobNearestBigCityDesc({ city: post._nearestBigCity }) : ''
        return post.description + nearbyText
    }

    const defaultDescriptionFunction = postContent.description
    return typeof defaultDescriptionFunction === 'function' ? defaultDescriptionFunction(context) : defaultDescriptionFunction
}

const postTypeConfig = {
    getStatusManager: function getStatusManager(p = {}) {
        return defaultPostTypeConfig.getStatusManager({
            ...p,
            config: {
                requiredDataForStatus: {
                    position: { type: Object }
                },
                ...(p.config) ? p.config : {}
            }
        })
    },
    getConstants: getConstants,
    setContents: function setContents(p = {}) {

        const {
            wapp,
            name = 'job',
            routes,
            urlParams = [
                '/page/:pagination',
                '/sort/:sort',
                '/limit/:limit',
                '/city/:city',
                '/professions/:professions',
                '/softSkills/:softSkills',
                '/qualifications/:qualifications',
                '/languages/:languages'
            ],
            transformRequestParams,
            ...rest
        } = p

        const n = name
        const N = capitalize(n)
        const ns = (n.endsWith('y')) ? n.slice(0, -1) + 'ies' : n + 's'

        const r = defaultPostTypeConfig.setContents({
            ...p,
            name,
            urlParams,
            flexibleParams: true
        })

        wapp.router.replace([
            {
                path: routes[name + 'Route'] + '/:_id/:page',
                contentName: name,
                action: async function action(p) {

                    const { req, res, ...rest } = p

                    const page = rest.params.page

                    let r = { ...rest }

                    if ((page === 'fullview' && rest.status === 200 && !req.wappRequest.user) ||
                        (page === 'apply' && rest.status === 200 && !req.wappRequest.user) ||
                        (page === 'subscribe' && rest.status === 200 && !req.wappRequest.user)) {

                        const loginUrl = routes.accountRoute + '/login?redirect=' + encodeURIComponent(rest.requestPath)

                        if (wapp.target === 'node') {

                            res.wappResponse.status(302)
                            res.writeHead(302, {
                                'Location': loginUrl
                            })
                            res.end()

                            return
                        } else {

                            r = await wapp.router.routeManager.resolve({
                                path: routes.accountRoute + '/login',
                                req,
                                res
                            })
                            if (r.status === 200) {
                                r.status = 302
                            }
                        }
                    }

                    return r
                }
            },
            {
                path: routes[name + 'Route'] + '/:_id/:page/:pageType',
                contentName: name,
                action: async function action(p) {

                    const { req, res, ...rest } = p

                    const page = rest.params.page

                    let r = { ...rest }

                    // A 4. lépés (jelölt-elvárások) csak adminnak érhető el; mást az aktiválásra
                    // küldünk, hogy a lépés URL-jén se maradhasson bent.
                    const routeUser = req.wappRequest.user
                    if (page === 'edit' && rest.params.pageType === 'step4' && rest.status === 200 &&
                        !(routeUser?._status_isFeatured || routeUser?._isEditor)) {

                        const activateUrl = routes[name + 'Route'] + '/' + rest.params._id + '/edit/activate'

                        if (wapp.target === 'node') {
                            res.wappResponse.status(302)
                            res.writeHead(302, { 'Location': activateUrl })
                            res.end()
                            return
                        }

                        r = await wapp.router.routeManager.resolve({ path: activateUrl, req, res })
                        if (r.status === 200) {
                            r.status = 302
                        }
                        return r
                    }

                    if ((page === 'fullview' && rest.status === 200 && !req.wappRequest.user) ||
                        (page === 'apply' && rest.status === 200 && !req.wappRequest.user) ||
                        (page === 'subscribe' && rest.status === 200 && !req.wappRequest.user)) {

                        const loginUrl = routes.accountRoute + '/login?redirect=' + encodeURIComponent(rest.requestPath)

                        if (wapp.target === 'node') {

                            res.wappResponse.status(302)
                            res.writeHead(302, {
                                'Location': loginUrl
                            })
                            res.end()

                            return
                        } else {

                            r = await wapp.router.routeManager.resolve({
                                path: routes.accountRoute + '/login',
                                req,
                                res
                            })
                            if (r.status === 200) {
                                r.status = 302
                            }
                        }
                    }

                    return r
                }
            }
        ])

        const listContent = getListContent({ wapp, name, routes, urlParams, App, ...rest })
        const postContent = getDefaultContent({ wapp, name, routes, urlParams, App, ...rest })

        function _transformRequestParams({ requestParams }) {
            return requestParams
        }

        async function requestForList(props) {

            const {
                wapp,
                req,
                res,
                disableCache,
                transformRequestParams = _transformRequestParams,
                params = res.wappResponse.route.params,
                query = req.wappRequest.query,
                url = req.url
            } = props

            const wappResponse = res.wappResponse

            const postStatusManager = wapp.getTargetObject().postTypes.findPostType({ name }).statusManager
            const userStatusManager = wapp.getTargetObject().postTypes.findPostType({ name: 'user' }).statusManager

            const listData = wappResponse.store.getState('res.graphql.query.' + name + 'FindMany.listData') || {}
            const listDataSort = listData.sort || []

            /*

              word search for ads:

                - accented characters and capital letters do not count
                - it only searches for words, not word parts, there is an OR relationship between the words
                - the most important in the row arrangement is [profession, business name, address of work], then comes the title and content

              there is an AND relationship between the city and the word search

              city finder for ads:

                - accented characters and capital letters do not count
                - it only searches for words, not word parts, there is an OR relationship between the words
                - relevancy of this does not matter when sorting, if it is used together with word search, it only filters its results

            * */

            if (query.search) {
                listDataSort.push({ key: 'RELEVANCE' })
                listDataSort.push({ key: 'TEXTSCORE' })
            }

            const defaultSort = listDataSort[0]?.key || ''

            let sort = (params.sort && listDataSort && listDataSort.map((p) => p.key).find((key) => key?.toLowerCase() === params.sort.toLowerCase())) || defaultSort

            if (sort === 'TEXTSCORE' || sort === 'RELEVANCE') {
                sort = ''
            }

            const page = params.page
            const pagination = !isNaN(Number(params.pagination)) && Number(params.pagination) ? Number(params.pagination) : 1

            const perPageFormData = listData.perPage
            const limitPerPage = perPageFormData.limit || 100
            const defaultPerPage = perPageFormData.default || 20
            const perPage = (params.limit && !isNaN(Number(params.limit)) && Number(params.limit) <= limitPerPage && Number(params.limit) > 1) ? Number(params.limit) : defaultPerPage

            const formData = wappResponse.store.getState('res.graphql.query.' + name + 'FindMany.formData')

            const latinGroups = [
                ['a', 'á'],
                ['e', 'é'],
                ['i', 'í'],
                ['i', 'í'],
                ['o', 'ó', 'ö', 'ő'],
                ['u', 'ú', 'ü', 'ű']
            ]

            const city = query.city || params.city

            const cityString = city ?
                city
                    .split(' ')
                    .filter((t) => t)
                    .map((t) => {
                        return t.split('').reduce((t, char) => {
                            const group = latinGroups.find((g) => g.indexOf(char) > -1)
                            if (group) {
                                t = t + `[${group.join('|')}]`
                            } else {
                                t = t + char
                            }
                            return t
                        }, '')
                    })
                    .join('|')
                : ''

            const filter = urlParams.reduce((o, urlParamText) => {
                if (!urlParamText.startsWith('/page/:') && !urlParamText.startsWith('/sort/:') && !urlParamText.startsWith('/limit/:') && !urlParamText.startsWith('/city/:')) {
                    const paramNameN = urlParamText.startsWith('/') ? 1 : 0
                    const paramName = urlParamText.split('/')[paramNameN]
                    if (params[paramName] && formData['filter.' + paramName]) {
                        const { schemaType, multiple } = formData['filter.' + paramName]
                        let value = params[paramName]
                        if (multiple) {
                            try {
                                value = (value.startsWith('[') && value.endsWith(']')) ? JSON.parse(value) : value.split(',')
                            } catch (e) {
                            }
                        } else {
                            if (schemaType === 'Float' || schemaType === 'Int') {
                                value = Number(value)
                            }
                        }
                        if (typeof value !== 'undefined') {
                            o[paramName] = value
                        }
                    }
                }
                return o
            }, {})

            const authorStatus =
                (page === 'lowauthorstatus') ?
                    {
                        _author_status: {
                            lt: userStatusManager.getMinStatus()
                        }
                    } :
                    (page === 'banned' || page === 'deleted' || page === 'missingdata' || page === 'protected') ? {
                            _author_status: {
                                gt: userStatusManager.getBannedStatus() - 1
                            }
                        } :
                        {
                            _author_status: {
                                gt: userStatusManager.getMinStatus() - 1
                            }
                        }

            const status =
                (page === 'banned') ?
                    { gt: postStatusManager.getBannedStatus() - 1, lt: postStatusManager.getDeletedStatus() } :
                    (page === 'deleted') ?
                        { gt: postStatusManager.getDeletedStatus() - 1, lt: postStatusManager.getDefaultStatus() } :
                        (page === 'missingdata') ?
                            { gt: postStatusManager.getDefaultStatus() - 1, lt: postStatusManager.getMinStatus() } :
                            (page === 'protected') ?
                                { gt: postStatusManager.getFeaturedStatus() - 1 } :
                                (page === 'lowauthorstatus') ?
                                    { gt: postStatusManager.getBannedStatus() - 1 } :
                                    { gt: postStatusManager.getMinStatus() - 1 }

            const requestParams = transformRequestParams({
                requestParams: {
                    requestName: name + 'FindMany',
                    args: {
                        filter: {
                            ...(query.search) ? { search: query.search } : {},
                            ...(Object.keys(filter).length) ? filter : {},
                            _operators: {
                                _status: status,
                                ...authorStatus,
                                ...(cityString) ? {
                                    city: {
                                        regex: `/(^|[\s"])(${cityString})(?![^\s"])/gi`
                                    }
                                } : {},
                                _jobStatus: {
                                    gte: 0
                                },
                                ...page === 'lowview' ? {
                                    _views: { lt: 100 },
                                    _jobStatus: {
                                        gte: 1
                                    }
                                } : {},
                                ...page === 'lowemployees' ? {
                                    _employeesCount: { lt: 4 },   // kevesebb mint 4 jelentkező

                                    activeIntervalsStartDate: {
                                        lte: new Date(Date.now() - 14 * 24 * 60 * 60 * 1000),   // legalább 14 napja fut
                                        gt: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000)   // még nem érte el a 30 napot
                                    },

                                    _jobStatus: {
                                        gte: 1
                                    }
                                } : {},
                                ...page === 'lowemployeesdsa' ? {
                                    _employeesCount: { lt: 4 },   // kevesebb mint 4 jelentkező

                                    activeIntervalsStartDate: {
                                        lte: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000),   // legalább 3 napja fut
                                        gt: new Date(Date.now() - 14 * 24 * 60 * 60 * 1000)   // még nem érte el a 14 napot
                                    },

                                    _jobStatus: {
                                        gte: 1
                                    }
                                } : {},
                                ...page === 'noformepageview' ? {
                                    _noFormePageview: { eq: 1 },
                                    _jobStatus: {
                                        gte: 1
                                    }
                                } : {}
                            }
                        },
                        ...(sort) ? { sort } : {},
                        page: pagination,
                        perPage
                    }
                }
            })

            const storageKey = name + '-posts-' + url + '-' + JSON.stringify(requestParams)

            if (wapp.target === 'web' && req.history?.action === 'POP' && !disableCache) {
                const response = res.wappResponse.store.getState('res.cache.' + storageKey)
                if (response) {
                    res.wappResponse.store.dispatch(wapp.states.stateManager.actions.res({
                        type: 'INS_RES',
                        name: 'responses',
                        value: { [requestParams.requestName]: response }
                    }))
                    return {
                        [requestParams.requestName]: response
                    }
                }
            }

            const response = await wapp.requests.send({ ...requestParams, req, res })

            if (wapp.target === 'web' && response && response[requestParams.requestName]) {
                res.wappResponse.store.dispatch(wapp.states.stateManager.actions.res({
                    type: 'INS_RES',
                    name: 'cache',
                    value: { [storageKey]: response[requestParams.requestName] }
                }))
            }

            return response

        }

        function getPost(res) {
            const wappResponse = res.wappResponse
            const route = wappResponse.route
            const { params } = route

            const rawId = params._id
            const _id = extractMongoIdFromParam(rawId)

            const posts = [
                wappResponse.store.getState('res.responses.' + name + 'FindById')
            ]

            return posts.find((p) => p?._id === _id)
        }

        let reqUserForPost = null

        function extractMongoIdFromParam(idParam) {
            if (!idParam || typeof idParam !== 'string') return idParam
            const match = idParam.match(/[0-9a-fA-F]{24}$/)
            return match ? match[0] : idParam
        }

        async function requestForPost(props) {

            const { req, res, wapp } = props

            const wappResponse = res.wappResponse
            const post = wappResponse.store.getState('res.responses.' + name + 'FindById')
            const route = wappResponse.route
            const { params } = route

            const rawId = params._id
            const _id = extractMongoIdFromParam(rawId)

            const statusManager = wapp.getTargetObject().postTypes.findPostType({ name }).statusManager

            await runPostTypesConfig({ action: 'requestFor' + N + 'Page', p: { wapp, req, res, statusManager } })

            if ((_id && !post) ||
                (_id && post && post._id !== _id) ||
                (_id && reqUserForPost?._id !== req.wappRequest.user?._id)) {
                reqUserForPost = { _id: req.wappRequest.user?._id }

                const requestParams = { requestName: name + 'FindById', args: { _id: _id }, req, res }
                const rp = transformRequestParams ? transformRequestParams({ requestParams }) : requestParams

                return await wapp.requests.send(rp)
            }

        }

        wapp.contents.add({
            [n]: {
                ...postContent,
                ComponentProps: {
                    TemplateProps: {
                        BeforeChildren: undefined, //PostHeader,
                        disableFooter: true
                    }
                },
                title: (context) => {
                    return getPostTitle({ context, getPost, postContent, getTitle: rest.getTitle, titles: rest.titles })
                },
                description: (context) => {
                    return getPostDescription({ context, getPost, postContent, titles: rest.titles })
                },
                ldJson: (context) => {

                    const { res, req } = context

                    try {
                        const post = getPost(res)
                        if (post?._id) {

                            const date = new Date(post.createdDate || post.createdDateText)

                            const validThrough = new Date()

                            validThrough.setDate(date.getDate() + 30)

                            return JSON.stringify({
                                '@context': 'https://schema.org/',
                                '@type': 'JobPosting',
                                'title': post.title,
                                'image': [
                                    ...(post.cover?.thumb) ? [post.cover.thumb] : post.thumb ? [post.thumb] : [],
                                    ...(post._author?.thumb) ? [post._author.thumb] : [],
                                    ...post.gallery ? post.gallery.map((image) => image.thumb) : []
                                ].map((url) => {
                                    if (url.startsWith('/')) {
                                        return req.wappRequest.protocol + '://' + req.wappRequest.hostname + url
                                    }
                                    return url
                                }),
                                'datePosted': date,
                                'validThrough': validThrough,
                                'description': post.content,
                                'hiringOrganization': {
                                    '@type': 'Organization',
                                    'name': post._author?.title
                                },
                                'employmentType': JSON.stringify(post.employmentType) || 'FULL_TIME',
                                'jobLocation': {
                                    '@type': 'Place',
                                    'address': {
                                        '@type': 'PostalAddress',
                                        'addressLocality': post.city,
                                        'postalCode': post.postCode,
                                        'addressCountry': 'HU'
                                    }
                                }
                            })

                        }
                    } catch (e) {
                        console.log('[APP] Can\'t include ld+json for a job', req.url, e)
                    }

                    return null
                },
                robots: (context) => {
                    const wappResponse = context.res.wappResponse
                    const route = wappResponse.route
                    const { params } = route
                    if (params?.page === 'apply' || params?.page === 'subscribe' || params?.page === 'fullview') {
                        return 'noindex,nofollow'
                    }
                    return 'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1'
                },
                request: async function(props) {
                    return await requestForPost(props)
                },
                canonical: (context) => {
                    const { req, res } = context
                    try {
                        const origin = req.wappRequest.protocol + '://' + req.wappRequest.hostname
                        const post = getPost(res)
                        const params = res.wappResponse.route.params
                        const rawId = params._id
                        const _id = extractMongoIdFromParam(rawId)
                        const page = params.page

                        if (post?.url && post?._id === _id && !page) {
                            return origin + post.url
                        }
                    } catch (e) {
                        console.log('[APP] An error occurred while trying to build canonical url for a job', req?.url, e)
                    }
                },
                image: (context) => {

                    const post = getPost(context.res)
                    const thumb = (post?._id && post.thumb) ? post.thumb : null

                    if (thumb) {
                        return postContent.image(context)
                    }

                    return post?.renderedThumb || undefined

                }
            },
            [ns]: {
                ...listContent,
                ComponentProps: {
                    TemplateProps: {
                        BeforeChildren: ListHeader,
                        BeforeChildrenProps: {
                            defaultTitle: (context) => {
                                const title = typeof listContent.title === 'function' ? listContent.title(context) : listContent.title
                                return title ? title.split(' | ')[0] : undefined
                            },
                            parentRoute: ({ res }) => {

                                const route = res.wappResponse.route
                                const { params } = route
                                const { page } = params

                                return routes[ns + 'Route'] + (page ? '/' + page : '')
                            }
                        }
                    }
                },
                title: (context) => {

                    const defaultTitleFunction =
                        typeof context.defaultTitle === 'function' || typeof context.defaultTitle === 'string'
                            ? context.defaultTitle
                            : listContent.title

                    const defaultTitle =
                        typeof defaultTitleFunction === 'function'
                            ? defaultTitleFunction(context)
                            : defaultTitleFunction

                    const defaultTitleStarts = defaultTitle ? defaultTitle.split(' | ')[0] : undefined

                    let title = getListPageTitle({ context, titles: rest.titles, name, suffix: ', munkák' })
                    if (defaultTitleStarts && title) {
                        title = `${defaultTitleStarts} - ${title}`
                    }
                    if (title) {
                        return `${rest.getTitle ? rest.getTitle({ ...context, title }) : title}`
                    }

                    return defaultTitle

                },
                description: (context) => {

                    const defaultDescriptionFunction =
                        typeof context.defaultDescription === 'function' || typeof context.defaultDescription === 'string'
                            ? context.defaultDescription
                            : listContent.description

                    const defaultDescription = typeof defaultDescriptionFunction === 'function' ?
                        defaultDescriptionFunction(context) :
                        defaultDescriptionFunction

                    const titles = rest.titles

                    const description = getListPageDescription({ context, titles, name })

                    if (description) {
                        return description
                    }

                    return defaultDescription
                },
                ldJson: (context) => {
                    const { res, req } = context

                    try {

                        const origin = req.wappRequest.protocol + '://' + req.wappRequest.hostname

                        const defaultTitleFunction =
                            typeof context.defaultTitle === 'function' || typeof context.defaultTitle === 'string'
                                ? context.defaultTitle
                                : listContent.title

                        const defaultTitle =
                            typeof defaultTitleFunction === 'function'
                                ? defaultTitleFunction(context)
                                : defaultTitleFunction

                        function getItemList() {

                            const jobs = res.wappResponse.store.getState('res.responses.' + name + 'FindMany')

                            if (!jobs?.items?.length) {
                                return null
                            }

                            const itemListElement = jobs.items
                                .filter((job) => job && (job.url || job._id) && job.title)
                                .map((job, index) => {
                                    let jobUrl = job.url || null
                                    if (jobUrl && jobUrl.startsWith('/')) {
                                        jobUrl = origin + jobUrl
                                    }

                                    const rawDate = job.createdDate || job.createdDateText || null
                                    const datePosted = rawDate ? new Date(rawDate) : null

                                    return {
                                        '@type': 'ListItem',
                                        position: index + 1,
                                        item: {
                                            '@type': 'JobPosting',
                                            title: getPostTitle({
                                                context,
                                                getPost: () => job,
                                                getTitle: rest.getTitle,
                                                postContent,
                                                titles: rest.titles
                                            }),
                                            description: getPostDescription({
                                                context,
                                                getPost: () => job,
                                                postContent,
                                                titles: rest.titles
                                            }),
                                            datePosted: datePosted || undefined,
                                            hiringOrganization: job._author?.title
                                                ? {
                                                    '@type': 'Organization',
                                                    name: job._author.title
                                                }
                                                : undefined,
                                            jobLocation: job.city
                                                ? {
                                                    '@type': 'Place',
                                                    address: {
                                                        '@type': 'PostalAddress',
                                                        addressLocality: job.city,
                                                        postalCode: job.postCode,
                                                        addressCountry: 'HU'
                                                    }
                                                }
                                                : undefined,
                                            url: jobUrl || undefined
                                        }
                                    }
                                })
                                .filter((item) => !!item.item.url)

                            if (!itemListElement.length) {
                                return null
                            }

                            const defaultDescriptionFunction = listContent.description
                            const defaultDescription = typeof defaultDescriptionFunction === 'function' ? defaultDescriptionFunction(context) : defaultDescriptionFunction
                            const titles = rest.titles

                            const description = getListPageDescription({ context, titles, name })

                            const defaultTitleStarted = defaultTitle ? defaultTitle.split(' | ')[0] : undefined
                            let pageTitle = getListPageTitle({ context, titles, name, suffix: ', munkák' }) || null
                            if (defaultTitleStarted && pageTitle) {
                                pageTitle = `${defaultTitleStarted} - ${pageTitle}`
                            }
                            if (!pageTitle) {
                                pageTitle = defaultTitleStarted || defaultTitle
                            }

                            return {
                                '@context': 'https://schema.org',
                                '@type': 'CollectionPage',
                                name: pageTitle,
                                description: description || defaultDescription,
                                mainEntity: {
                                    '@type': 'ItemList',
                                    itemListElement
                                }
                            }

                        }

                        function getBreadcrumb() {

                            const profession = getProfession(context)

                            const query = req.wappRequest.query || {}
                            const params = res.wappResponse.route.params || {}

                            const searchText = [
                                query.search ? 'search=' + query.search : '',
                                query.city ? 'city=' + query.city : ''
                            ].filter(Boolean).join('&')

                            const sortPath = query.search ? '/sort/relevance' : ''
                            const cityPath = params.city ? '/city/' + params.city : ''

                            const route = res.wappResponse.route
                            const page = route.params?.page
                            const baseRoute = (context.defaultPath || routes[ns + 'Route']) + (page ? '/' + page : '')

                            const makeHref = (path) => path + cityPath + sortPath + (searchText ? '?' + searchText : '')

                            const homeLabel = rest.menus?.homeMenu || 'Home'

                            const breadcrumbs = [
                                {
                                    name: homeLabel,
                                    href: '/'
                                },
                                {
                                    name: defaultTitle && defaultTitle.split(' | ')[0],
                                    href: makeHref(baseRoute)
                                }
                            ]

                            if (profession?.parentProfessions?.length) {
                                const parentProf = profession.parentProfessions[0]
                                breadcrumbs.push({
                                    name: parentProf.title,
                                    href: makeHref(baseRoute + '/professions/' + parentProf.slug)
                                })
                            }

                            if (profession) {
                                breadcrumbs.push({
                                    name: profession.title,
                                    href: makeHref(baseRoute + '/professions/' + profession.slug)
                                })
                            }

                            return {
                                '@context': 'https://schema.org',
                                '@type': 'BreadcrumbList',
                                itemListElement: breadcrumbs
                                    .filter(b => b && b.name && b.href)
                                    .map((b, index) => ({
                                        '@type': 'ListItem',
                                        position: index + 1,
                                        name: b.name,
                                        item: b.href.startsWith('http')
                                            ? b.href
                                            : origin + b.href
                                    }))
                            }

                        }

                        const breadcrumb = getBreadcrumb()
                        const itemList = getItemList()

                        const ldJson = [itemList, breadcrumb].filter((o) => o)

                        return ldJson?.length ? JSON.stringify(ldJson) : null

                    } catch (e) {
                        console.log('[APP] Can\'t include ld+json for a jobs list', req?.url, e)
                    }

                    return null
                },
                image: (context) => {

                    // lista-oldal + város-találat → a város OG-képe (a dictből), a profession-thumb ELÉ
                    const cityOgImage = getCityOgImage(context)
                    if (cityOgImage) {
                        return cityOgImage
                    }

                    const profession = getProfession(context)

                    if (profession?.title) {

                        let thumb = profession.thumb || null

                        if (!thumb) {
                            if (profession.parentProfessions?.length) {
                                const found = profession.parentProfessions.find((profession) => {
                                    return profession?.thumb
                                })
                                thumb = found?.thumb || null
                            }
                        }

                        if (thumb && thumb.startsWith('/thumb')) {
                            thumb = thumb.replace('/thumb', '/thumb/2')
                        }

                        if (thumb) {

                            try {

                                const { req } = context
                                const hostname = req.wappRequest.hostname
                                const protocol = req.wappRequest.protocol
                                const url = new URL(protocol + '://' + hostname + thumb)
                                if (url.searchParams.get('crop')) {

                                    const crop = JSON.parse(url.searchParams.get('crop'))
                                    const width = crop.croppedAreaPixels.width
                                    const height = crop.croppedAreaPixels.height
                                    const maxDim = 800
                                    const scale = Math.min(maxDim / width, maxDim / height)

                                    return {
                                        width: Math.round(width * scale),
                                        height: Math.round(height * scale),
                                        thumb
                                    }
                                }

                            } catch (e) {

                            }

                        }

                        return thumb || undefined

                    }

                    return undefined

                },
                imageAlt: (context) => {

                    const profession = getProfession(context)
                    if (profession?.title) {
                        return profession.title
                    }

                    return undefined

                },
                canonical: (context) => {
                    try {
                        const { req } = context

                        const origin = req.wappRequest.protocol + '://' + req.wappRequest.hostname
                        const fullUrl = req.wappRequest.url
                        const query = req.wappRequest.query || {}

                        const [pathname] = fullUrl.split('?')

                        const cityFromQuery =
                            typeof query.city === 'string' && query.city.trim() !== ''
                                ? query.city.trim()
                                : null

                        if (!cityFromQuery) {
                            return null
                        }

                        const matches = findCityBySlug(cityFromQuery, cityIndex)
                        if (!matches || matches.length === 0) {
                            return null
                        }

                        const slug = matches[0].slug

                        const jobsPrefix = '/jobs'
                        const jobsIndex = pathname.indexOf(jobsPrefix)
                        if (jobsIndex === -1) {
                            return null
                        }

                        let rest = pathname.slice(jobsPrefix.length)

                        rest = rest.replace(/\/city\/[^/]+/, '')

                        const profMatch = rest.match(/^\/professions\/([^/]+)(.*)$/)

                        let canonicalPath
                        if (profMatch) {
                            const professionSlug = profMatch[1]
                            const tail = profMatch[2] || ''
                            canonicalPath = `${jobsPrefix}/professions/${professionSlug}/city/${slug}${tail}`
                        } else {
                            canonicalPath = `${jobsPrefix}/city/${slug}${rest}`
                        }

                        const buildQueryString = (obj) => {
                            const entries = Object.entries(obj).filter(
                                ([key, val]) => key !== 'city' && val != null && val !== ''
                            )

                            if (!entries.length) {
                                return ''
                            }

                            return (
                                '?' +
                                entries
                                    .map(
                                        ([key, val]) =>
                                            encodeURIComponent(key) + '=' + encodeURIComponent(val)
                                    )
                                    .join('&')
                            )
                        }

                        const qs = buildQueryString(query)

                        return origin + canonicalPath + qs

                    } catch (e) {
                        console.log('[APP] An error occurred while trying to build canonical url for jobs list', e)
                    }

                    return null
                },
                request: async function(props) {
                    return await requestForList(props)
                },
                robots: () => {
                    return 'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1'
                }
            }
        })

        const draftName = 'draft'
        const drafts = (draftName.endsWith('y')) ? draftName.slice(0, -1) + 'ies' : draftName + 's'

        wapp.contents.add({
            [drafts]: {
                ...wapp.contents.get(ns),
                request: async function({ wapp, req, res }) {
                    await replaceContentForArchivePage({
                        wapp,
                        req,
                        res,
                        defaultPath: '/' + drafts,
                        replacePath: routes[ns + 'Route'],
                        transformRequestParams: ({ requestParams }) => {
                            requestParams.args.filter._operators._jobStatus = { lt: 0 }
                            return requestParams
                        },
                        ComponentProps: {
                            TemplateProps: {
                                BeforeChildrenProps: {
                                    defaultTitle: rest.titles['draftsTitle'] || rest.titles[ns + 'Title']
                                }
                            }
                        }
                    })
                }
            }
        })

        wapp.router.add([
            { path: '/' + drafts + '/*', contentName: drafts }
        ])


        return r
    },
    requestForUserPage: async function requestForUserPage(p = {}) {

        const { res, name = 'job' } = p

        const ns = (name.endsWith('y')) ? name.slice(0, -1) + 'ies' : name + 's'

        const wappResponse = res.wappResponse
        const route = wappResponse.route
        const { params } = route
        const { _id, page, pageType } = params

        const isDraft = (page === ns && (pageType === 'drafts') && _id)
        const isInactive = (page === ns && (pageType === 'inactive') && _id)

        return await defaultPostTypeConfig.requestForUserPage({
            ...p,
            name,
            transformRequestParams: ({ requestParams }) => {
                if (isDraft) {
                    requestParams.args.filter._operators._jobStatus = {
                        lt: 0
                    }
                } else if (isInactive) {
                    requestParams.args.filter._jobStatus = 0
                } else if (!pageType) {
                    requestParams.args.filter._operators._jobStatus = {
                        gt: 0
                    }
                }
                return requestParams
            },
            ...isDraft || isInactive ? {
                pageType: ''
            } : {}
        })
    },
    getComponent: function(p) {

        const name = 'job'
        const ns = (name.endsWith('y')) ? name.slice(0, -1) + 'ies' : name + 's'
        const N = capitalize(name)

        const { context, appContext } = p
        const { routes /*userStatusManager*/ } = appContext

        const { res, req } = context
        const route = res.wappResponse.route
        const requestPath = route.requestPath
        const { pageType } = route.params

        if (
            (requestPath.startsWith(routes[name + 'Route'])) ||
            (requestPath.startsWith(routes[ns + 'Route']))
        ) {

            function removeJobUrl(url = window.location.href) {
                try {
                    const fullUrl = new URL(url)
                    fullUrl.searchParams.delete(name)
                    return fullUrl.href.split(fullUrl.origin)[1]
                } catch (e) {
                }
            }

            function getJobUrl(post, url = window.location.href) {
                try {
                    const fullUrl = new URL(url)
                    fullUrl.searchParams.delete(name)
                    fullUrl.searchParams.append(name, post._id)
                    return fullUrl.href.split(fullUrl.origin)[1]
                } catch (e) {
                }
            }

            const postInDrawer = {}

            let startUrl

            let _onSubmit

            const pages = {
                new: New,
                edit: Edit,
                activate: Activate,
                content: Content
            }

            const defaultComponentProps = {
                pageProps: {
                    showAuthor: true,
                    showThumbnail: true,
                    GalleryProps: {
                        maxImage: 3
                    }
                },
                PaperComponentProps: {
                    /*color: undefined,
                    elevation: 0,
                    style: {
                        padding: 0
                    }*/
                },
                HeaderComponent: () => null
            }

            const user = req.wappRequest.user
            const isAdmin = (user && user._status_isFeatured) || (user && user._isEditor)

            const requestKeys = [name + 'FindById']
            const post = requestKeys.map((requestName) => res.wappResponse.store.getState('res.responses.' + requestName)).find((r) => r?._id)

            const isAuthor = ((user?._id && user._id.toString() === post?._author) || (user?._id && user._id.toString() === post?._author?._id))
            const isAuthorOrAdmin = (isAuthor || isAdmin)

            if (requestPath.startsWith(routes[name + 'Route']) && post?._jobStatus < 0 && !isAuthorOrAdmin) {
                return null
            }

            req.wappRequest.requestPath = routes[ns + 'Route']

            const enablePostInDrawer = false

            const { device } = appContext
            const isMobile = (device.type === 'mobile' || device.type === 'tablet' || device.type === 'wearable')

            function beforeSetUser(user) {

                if (!user) {
                    return null
                }

                return {
                    ...user,
                    _status_isFeatured: user?._status_isFeatured || user?._isEditor
                }
            }

            function getMenuContext(type, context) {
                if (type === 'header') {
                    return {
                        ...context,
                        getPropsForMenuItemProps: (p) => {
                            const r = context.getPropsForMenuItemProps(p)
                            return {
                                ...r,
                                user: beforeSetUser(r.user)
                            }
                        }
                    }
                }
                return context
            }

            function getPostContext(context) {
                return {
                    ...context,
                    user: beforeSetUser(context.user)
                }
            }

            return defaultPostTypeConfig.getComponent({
                ...p,
                name,
                archiveComponentProps: {
                    type: 'cardList',
                    selectable: false,
                    disablePageInfo: true,
                    infiniteScroll: !isMobile,
                    accessForEditor: true,
                    beforeSetUser,
                    ...enablePostInDrawer ? {
                        onClick: async (e, post) => {
                            if (postInDrawer.actions) {
                                e.preventDefault()
                                e.stopPropagation()
                                const newUrl = getJobUrl(post)
                                window.history.replaceState(window.history.state, undefined, newUrl)
                                await postInDrawer.actions.setPostId(post._id)
                            }
                        },
                        getMenuProps: (props) => {
                            _onSubmit = props.onSubmit
                            return defaultGetMenuProps(props)
                        },
                        BeforePostsComponent: () => {

                            let shouldUpdate = false

                            return (
                                <>
                                    <PostInDrawer
                                        name={name}
                                        effect={({ actions }) => {
                                            postInDrawer.actions = actions
                                        }}
                                        onOpen={async () => {
                                            startUrl = window.location.href
                                        }}
                                        beforeClose={() => {
                                            const newUrl = removeJobUrl(startUrl)
                                            window.history.replaceState(window.history.state, undefined, newUrl)
                                        }}
                                        onClose={async () => {
                                            if (shouldUpdate) {
                                                const _post = postInDrawer.actions?.getPost()
                                                if (_post?._id) {
                                                    const requestKeys = [name + 'FindById']
                                                    const post = requestKeys.map((requestName) => res.wappResponse.store.getState('res.responses.' + requestName)).find((r) => r?._id)

                                                    if (_onSubmit) {
                                                        await _onSubmit(null, post?._id ? post : _post, name + 'CloseDrawer')
                                                    }
                                                }
                                            }
                                        }}
                                        maxWidth={'640px'}
                                        PostTypesComponentProps={{
                                            getProps: () => {
                                                return {
                                                    ...defaultComponentProps,
                                                    pageProps: {
                                                        ...defaultComponentProps.pageProps,
                                                        disableReplaceState: true,
                                                        TitleComponentProps: {
                                                            variant: 'h4'
                                                        },
                                                        onChange: () => {
                                                            shouldUpdate = true
                                                        }
                                                    },
                                                    propsForGetMenuProps: {
                                                        onSubmit: () => {
                                                            shouldUpdate = true
                                                        }
                                                    }
                                                }
                                            }
                                        }}
                                    />
                                </>
                            )
                        }
                    } : {}
                },
                componentProps: {
                    pages,
                    showAuthor: () => false,
                    getPageName: (props) => {
                        const r = defaultGetPageName({
                            ...props, user: {
                                ...props.user ? props.user : {},
                                _status_isFeatured: props.user?._status_isFeatured || props.user?._isEditor
                            }
                        })
                        if (r === 'edit' && pageType === 'activate') {
                            return 'activate'
                        }
                        return r
                    },
                    getProps: ({ pageName, post }) => {
                        if (pageName === 'content') {
                            return {
                                ...defaultComponentProps
                            }
                        }
                        if (pageName === 'new') {
                            return {
                                pageProps: {
                                    requestProps: {
                                        redirect: routes[name + 'Route'] + '/:_id/edit/step2',
                                        go: null
                                    },
                                    //successMessage: null,
                                    SubmitProps: {
                                        label: appContext.labels[name + 'NewNextToStep2Label']
                                    }
                                }
                            }
                        }
                        if (pageName === 'edit' && (pageType !== 'step1' && pageType !== 'step2' && pageType !== 'step3' && pageType !== 'step4' && pageType !== 'activate')) {
                            return {
                                pageProps: {
                                    requestName: name + 'SaveStep1',
                                    requestProps: {
                                        redirect: routes[name + 'Route'] + '/:_id/edit/step2',
                                        go: null
                                    },
                                    //successMessage: null,
                                    SubmitProps: {
                                        label: post?._status_isNotDeleted ? appContext.labels[name + 'EditNextToStep2Label'] : appContext.labels['restore' + N + 'SubmitLabel']
                                    }
                                }
                            }
                        }
                        if (pageName === 'edit' && pageType === 'step1') {
                            return {
                                pageProps: {
                                    requestName: name + 'SaveStep1',
                                    requestProps: {
                                        redirect: routes[name + 'Route'] + '/:_id/edit/step2',
                                        go: null
                                    },
                                    //successMessage: null,
                                    SubmitProps: {
                                        label: post?._status_isNotDeleted ? appContext.labels[name + 'EditNextToStep2Label'] : appContext.labels['restore' + N + 'SubmitLabel']
                                    }
                                }
                            }
                        }
                        if (pageName === 'edit' && pageType === 'step2') {
                            return {
                                pageProps: {
                                    requestName: name + 'SaveStep2',
                                    requestProps: {
                                        redirect: routes[name + 'Route'] + '/:_id/edit/step3',
                                        go: null
                                    },
                                    //successMessage: null,
                                    SubmitProps: {
                                        label: post?._status_isNotDeleted ? appContext.labels[name + 'EditNextToStep3Label'] : appContext.labels['restore' + N + 'SubmitLabel']
                                    },
                                    PrevProps: {
                                        href: routes[name + 'Route'] + '/' + post._id + '/edit/step1'
                                    }
                                }
                            }
                        }
                        if (pageName === 'edit' && pageType === 'step3') {
                            return {
                                pageProps: {
                                    requestName: name + 'SaveStep3',
                                    requestProps: {
                                        // A 4. lépés (jelölt) csak adminnak létezik; a hirdető innen
                                        // egyből az aktiválásra megy.
                                        redirect: !post?._requiredData ? routes[name + 'Route'] + '/' + post._id + '/edit/step2' : isAdmin ? routes[name + 'Route'] + '/:_id/edit/step4' : routes[name + 'Route'] + '/:_id/edit/activate',
                                        go: null
                                    },
                                    //successMessage: null,
                                    SubmitProps: {
                                        label: post?._status_isNotDeleted ? appContext.labels[name + (isAdmin ? 'EditNextToStep4Label' : 'EditNextToActivateLabel')] : appContext.labels['restore' + N + 'SubmitLabel']
                                    },
                                    PrevProps: {
                                        href: routes[name + 'Route'] + '/' + post._id + '/edit/step2'
                                    }
                                }
                            }
                        }
                        // A 4. lépés csak adminnak; a hirdetőt visszaküldjük a 3. lépésre.
                        if (pageName === 'edit' && pageType === 'step4' && !isAdmin) {
                            return {
                                pageProps: {
                                    requestName: name + 'SaveStep3',
                                    requestProps: {
                                        redirect: routes[name + 'Route'] + '/:_id/edit/activate',
                                        go: null
                                    },
                                    SubmitProps: {
                                        label: post?._status_isNotDeleted ? appContext.labels[name + 'EditNextToActivateLabel'] : appContext.labels['restore' + N + 'SubmitLabel']
                                    },
                                    PrevProps: {
                                        href: routes[name + 'Route'] + '/' + post._id + '/edit/step2'
                                    }
                                }
                            }
                        }
                        if (pageName === 'edit' && pageType === 'step4') {
                            return {
                                pageProps: {
                                    requestName: name + 'SaveStep4',
                                    requestProps: {
                                        redirect: !post?._requiredData ? routes[name + 'Route'] + '/' + post._id + '/edit/step2' : routes[name + 'Route'] + '/:_id/edit/activate',
                                        go: null
                                    },
                                    //successMessage: null,
                                    SubmitProps: {
                                        label: post?._status_isNotDeleted ? appContext.labels[name + 'EditNextToActivateLabel'] : appContext.labels['restore' + N + 'SubmitLabel']
                                    },
                                    PrevProps: {
                                        href: routes[name + 'Route'] + '/' + post._id + '/edit/step3'
                                    }
                                }
                            }
                        }
                        if ((pageName === 'edit' || pageName === 'activate') && pageType === 'activate') {
                            return {
                                getTitle: () => {
                                    return appContext.titles['activate' + N + 'Title']
                                },
                                pageProps: {
                                    PrevProps: {
                                        href: routes[name + 'Route'] + '/' + post._id + '/edit/' + (isAdmin ? 'step4' : 'step3')
                                    }
                                }
                            }
                        }
                        return {}
                    },
                    getMenuContext,
                    getPostContext
                }
            })
        }
    },
    userPageFunctions: function(p) {

        const { context, appContext, postContext } = p

        const n = 'job'
        const ns = (n.endsWith('y')) ? n.slice(0, -1) + 'ies' : n + 's'
        const N = capitalize(n)
        const Ns = capitalize(ns)

        const r = defaultPostTypeConfig.userPageFunctions({
            ...p,
            name: n,
            nsPageProps: {
                selectable: false,
                type: 'cardList',
                disablePageInfo: true,
                getMenu: (props) => {
                    const menu = defaultGetMenu(props)
                    return [
                        {
                            label: appContext.menus[n + 'ListActionApplies'],
                            role: (p) => {
                                const isAdmin = p.user && p.user._status_isFeatured && !p.user._isEditor
                                const isAuthor = ((p.user?._id && p.user?._id === p.post?._author) || (p.user?._id && p.user?._id === p.post?._author?._id))
                                return p.post?._jobStatus > 0 && (isAdmin || isAuthor)
                            },
                            featured: true,
                            disableParentRoute: true,
                            href: ({ post }) => {
                                const _author = post._author?._id || post._author
                                if (_author) {
                                    return appContext.routes['userRoute'] + '/' + _author + appContext.routes['userAppliesRoute'] + '/forme?job=' + post._id
                                }
                                return appContext.routes[n + 'Route'] + '/' + post._id
                            },
                            featuredMenuItemProps: {
                                Component: Button,
                                variant: 'contained',
                                size: 'default',
                                color: 'tertiary',
                                disableElevation: false,
                                style: {
                                    alignSelf: 'center'
                                }
                            }
                        },
                        {
                            label: () => {
                                return appContext.menus[n + 'ListActionRequiredData']
                            },
                            role: (p) => {
                                const isAdmin = p.user && p.user._status_isFeatured && !p.user._isEditor
                                const isAuthor = ((p.user?._id && p.user?._id === p.post?._author) || (p.user?._id && p.user?._id === p.post?._author?._id))
                                return !p.post?._requiredData && p.post?._jobStatus < 0 && (isAdmin || isAuthor)
                            },
                            featured: true,
                            disableParentRoute: true,
                            href: ({ post }) => {
                                return appContext.routes[n + 'Route'] + '/' + post._id + '/edit/step2'
                            },
                            featuredMenuItemProps: {
                                Component: Button,
                                variant: 'contained',
                                size: 'default',
                                color: 'primary',
                                style: {
                                    alignSelf: 'center'
                                }
                            }
                        },
                        {
                            label: (p) => {
                                return p.post?._jobStatus === 0 ? appContext.menus[n + 'ListActionReActivate'] : appContext.menus[n + 'ListActionActivate']
                            },
                            role: (p) => {
                                const isAdmin = p.user && p.user._status_isFeatured && !p.user._isEditor
                                const isAuthor = ((p.user?._id && p.user?._id === p.post?._author) || (p.user?._id && p.user?._id === p.post?._author?._id))
                                return p.post?._requiredData && p.post?._jobStatus <= 0 && (isAdmin || isAuthor)
                            },
                            featured: true,
                            disableParentRoute: true,
                            href: ({ post }) => {
                                return appContext.routes[n + 'Route'] + '/' + post._id + '/edit/activate'
                            },
                            featuredMenuItemProps: {
                                Component: Button,
                                variant: 'contained',
                                size: 'default',
                                color: 'primary',
                                style: {
                                    alignSelf: 'center'
                                }
                            }
                        },
                        {
                            label: appContext.menus[n + 'ListActionEditFeatured'],
                            role: (p) => {
                                const isAdmin = p.user && p.user._status_isFeatured && !p.user._isEditor
                                const isAuthor = ((p.user?._id && p.user?._id === p.post?._author) || (p.user?._id && p.user?._id === p.post?._author?._id))
                                const isFeatured = p.post?._isFeatured
                                return isFeatured && p.post?._jobStatus > 0 && (isAdmin || isAuthor)
                            },
                            featured: true,
                            startIcon: <StarIcon />,
                            disableParentRoute: true,
                            href: ({ post }) => {
                                return appContext.routes[n + 'Route'] + '/' + post._id + '/edit/activate'
                            },
                            featuredMenuItemProps: {
                                Component: Button,
                                variant: 'outlined',
                                size: 'default',
                                color: 'featured',
                                style: {
                                    alignSelf: 'center'
                                }
                            }
                        },
                        {
                            label: appContext.menus[n + 'ListActionAddFeatured'],
                            role: (p) => {
                                const isAdmin = p.user && p.user._status_isFeatured && !p.user._isEditor
                                const isAuthor = ((p.user?._id && p.user?._id === p.post?._author) || (p.user?._id && p.user?._id === p.post?._author?._id))
                                const isFeatured = p.post?._isFeatured
                                return !isFeatured && p.post?._jobStatus > 0 && (isAdmin || isAuthor)
                            },
                            featured: true,
                            startIcon: <StarIcon />,
                            disableParentRoute: true,
                            href: ({ post }) => {
                                return appContext.routes[n + 'Route'] + '/' + post._id + '/edit/activate'
                            },
                            featuredMenuItemProps: {
                                Component: Button,
                                variant: 'outlined',
                                size: 'default',
                                color: 'featured',
                                style: {
                                    alignSelf: 'center'
                                }
                            }
                        },
                        ...menu
                    ]
                },
                beforeSetUser: function beforeSetUser(user) {

                    if (!user) {
                        return null
                    }

                    return {
                        ...user,
                        _status_isFeatured: user?._status_isFeatured || user?._isEditor
                    }
                },
                ...p.nsPageProps ? p.nsPageProps : {}
            }
        })

        const { res } = context

        const wappResponse = res.wappResponse
        const route = wappResponse.route
        const { params } = route
        const { pageType } = params

        //const {userStatusManager} = appContext;

        function addMenuItems(props) {

            const { appContext /*statusManager*/ } = props
            const { menus, routes /*userStatusManager*/ } = appContext

            return [
                /*{
                    label: menus[postContext.name + Ns + 'Menu'],
                    href: function(p) {
                        return (p.post?._id) ? '/' + p.post._id + routes[postContext.name + Ns + 'Route'] : routes[postContext.name + Ns + 'Route']
                    },
                    role: function(p) {
                        const isAdmin = p.user && p.user._status_isFeatured
                        const isAuthor = ((p.user?._id && p.user?._id === p.post?._author) || (p.user?._id && p.user?._id === p.post?._author?._id))
                        return (!isAdmin && !isAuthor) && (p.post?.activeJobs || p.post?._author?.activeJobs)
                    },
                    startIcon: <JobIcon />,
                    order: 20
                },*/
                {
                    divider: true,
                    label: 'Munkáltatók',
                    LabelProps: {
                        style: {
                            marginTop: '0.5em'
                        }
                    },
                    style: {
                        marginBottom: '0.5em'
                    },
                    role: function(p) {
                        const isAdmin = ((p.user && p.user._status_isFeatured) || (p.user && p.user._isEditor))
                        const isAuthor = ((p.user?._id && p.user?._id === p.post?._author) || (p.user?._id && p.user?._id === p.post?._author?._id))
                        return (isAdmin || isAuthor)
                    }
                },
                {
                    label: function(p) {
                        const isAuthor = ((p.user?._id && p.user?._id === p.post?._author) || (p.user?._id && p.user?._id === p.post?._author?._id))
                        return (isAuthor) ? menus['my' + Ns + 'Menu'] : menus[postContext.name + Ns + 'Menu']
                    },
                    role: function(p) {
                        const isAdmin = ((p.user && p.user._status_isFeatured) || (p.user && p.user._isEditor))
                        const isAuthor = ((p.user?._id && p.user?._id === p.post?._author) || (p.user?._id && p.user?._id === p.post?._author?._id))
                        return (isAdmin || isAuthor)
                    },
                    startIcon: <JobIcon />,
                    order: 21,
                    items: [
                        {
                            label: menus['new' + N + 'Menu'],
                            href: routes[n + 'Route'] + '/new',
                            role: function(p) {
                                return ((p.user?._id && p.user?._id === p.post?._author) || (p.user?._id && p.user?._id === p.post?._author?._id))
                            },
                            disableParentRoute: true
                        },
                        {
                            divider: true,
                            role: function(p) {
                                return ((p.user?._id && p.user?._id === p.post?._author) || (p.user?._id && p.user?._id === p.post?._author?._id))
                            }
                        },
                        {
                            label: function(p) {
                                const isAuthor = ((p.user?._id && p.user?._id === p.post?._author) || (p.user?._id && p.user?._id === p.post?._author?._id))
                                return (isAuthor) ? menus['my' + Ns + 'Menu'] : menus[postContext.name + Ns + 'Menu']
                            },
                            href: function(p) {
                                return (p.post?._id) ? '/' + p.post._id + routes[postContext.name + Ns + 'Route'] : routes[postContext.name + Ns + 'Route']
                            },
                            role: function(p) {
                                const isAdmin = ((p.user && p.user._status_isFeatured) || (p.user && p.user._isEditor))
                                const isAuthor = ((p.user?._id && p.user?._id === p.post?._author) || (p.user?._id && p.user?._id === p.post?._author?._id))
                                return (isAdmin || isAuthor)
                            }
                        },
                        {
                            label: function() {
                                return menus[postContext.name + Ns + 'InactiveMenu']
                            },
                            href: function(p) {
                                return (p.post?._id) ? '/' + p.post._id + routes[postContext.name + Ns + 'Route'] + '/inactive' : routes[postContext.name + Ns + 'Route'] + '/inactive'
                            },
                            role: function(p) {
                                const isAdmin = ((p.user && p.user._status_isFeatured) || (p.user && p.user._isEditor))
                                const isAuthor = ((p.user?._id && p.user?._id === p.post?._author) || (p.user?._id && p.user?._id === p.post?._author?._id))
                                return (isAdmin || isAuthor)
                            }
                        },
                        {
                            label: function() {
                                return menus[postContext.name + Ns + 'DraftsMenu']
                            },
                            href: function(p) {
                                return (p.post?._id) ? '/' + p.post._id + routes[postContext.name + Ns + 'Route'] + '/drafts' : routes[postContext.name + Ns + 'Route'] + '/drafts'
                            },
                            role: function(p) {
                                const isAdmin = ((p.user && p.user._status_isFeatured) || (p.user && p.user._isEditor))
                                const isAuthor = ((p.user?._id && p.user?._id === p.post?._author) || (p.user?._id && p.user?._id === p.post?._author?._id))
                                return (isAdmin || isAuthor)
                            }
                        },
                        {
                            divider: true,
                            role: function(p) {
                                return ((p.user && p.user._status_isFeatured) || (p.user && p.user._isEditor))
                            }
                        },
                        {
                            label: function() {
                                return menus['deleted' + Ns + 'Menu']
                            },
                            href: function(p) {
                                return (p.post?._id) ? '/' + p.post._id + routes[postContext.name + Ns + 'Route'] + '/deleted' : routes[postContext.name + Ns + 'Route'] + '/deleted'
                            },
                            role: function(p) {
                                return ((p.user && p.user._status_isFeatured) || (p.user && p.user._isEditor))
                            }
                        },
                        {
                            label: function() {
                                return menus['banned' + Ns + 'Menu']
                            },
                            href: function(p) {
                                return (p.post?._id) ? '/' + p.post._id + routes[postContext.name + Ns + 'Route'] + '/banned' : routes[postContext.name + Ns + 'Route'] + '/banned'
                            },
                            role: function(p) {
                                return p.user && p.user._status_isFeatured
                            }
                        }
                    ]
                }
            ]
        }

        function getFeaturedActions(props) {

            const { appContext } = props

            return [
                {
                    label: appContext.menus['new' + N + 'Menu'],
                    href: appContext.routes[n + 'Route'] + '/new',
                    role: function(p) {
                        // csak: fő dashboard (!p.page), a user álláshirdetés-listája (/jobs, nincs pageType) és a
                        // Az /jobs/inactive, /drafts stb. NEM.
                        const isAuthor = (p.user?._id && p.user?._id === p.post?._author) || (p.user?._id && p.user?._id === p.post?._author?._id)
                        return isAuthor && (!p.page || (p.page === ns && (!p.pageType)))
                    },
                    startIcon: <AddCircleIcon />,
                    disableParentRoute: true,
                    featured: true,
                    featuredMenuItemProps: {
                        color: 'secondary',
                        variant: 'contained',
                        Component: Button,
                        size: 'default'
                    }
                }
            ]
        }

        const parentRoute = appContext.routes[postContext.name + 'Route']

        function addContentMenuItems() {
            return [
                {
                    role: function(p) {
                        const { user, post } = p
                        const isAdmin = user && user._status_isFeatured
                        const isAuthor = ((user?._id && user._id === post?._author) || (user?._id && user._id === post?._author?._id))
                        return !isAdmin && !isAuthor && (post?.activeJobs)
                    },
                    order: 20,
                    Component: () => {

                        const postContext = useContext(PostContext)

                        const { user, post } = postContext

                        const isAuthor = ((user?._id && user?._id === post?._author) || (user?._id && user?._id === post?._author?._id))

                        return (
                            <Posts
                                name={n}
                                type={'cardList'}
                                label={isAuthor ? appContext.titles['my' + Ns + 'Title'] : appContext.titles['user' + Ns + 'Title']}
                                nextLabel={isAuthor ? appContext.labels['moreFromMy' + Ns + 'Title'] : appContext.labels['moreFromUser' + Ns + 'Title']}
                                LabelProps={{
                                    variant: 'h5',
                                    weight: 700
                                }}
                                requestParams={{
                                    page: 1,
                                    perPage: 5,
                                    _author: post?._id,
                                    filter: {
                                        _operators: {
                                            _jobStatus: {
                                                gt: 0
                                            }
                                        }
                                    }
                                }}
                                posts={[]}
                                postsSlice={[]}
                                fromRequest={true}
                                enableCache={false}
                                carousel={false}
                                NextProps={{
                                    href: parentRoute + ((post?._id) ? '/' + post._id + appContext.routes[postContext.name + Ns + 'Route'] : appContext.routes[postContext.name + Ns + 'Route']),
                                    color: undefined,
                                    size: 'default',
                                    variant: 'text'
                                }}
                                NextButtonContainerProps={{
                                    style: {
                                        justifyContent: 'flex-end'
                                    }
                                }}
                                nextButtonShowsOnlyIfCountGreaterThanLength={true}
                                disableMenu={false}
                                disableAvatars={true}
                            />
                        )
                    }
                }
            ]
        }

        function getPageName({ user, post, page /*statusManager*/ }) {

            const isAdmin = ((user && user._status_isFeatured) || (user && user._isEditor))
            const isAuthor = ((user?._id && user._id === post?._author) || (user?._id && user._id === post?._author?._id))
            const isAuthorOrAdmin = (isAdmin || isAuthor)
            //const authorIsAdmin = post && post._status_isFeatured

            return (
                (page === ns && !pageType) ||
                (page === ns && !isNaN(Number(pageType)) && Number(pageType) >= 1) ||
                (page === ns && pageType === 'deleted' && isAuthorOrAdmin) ||
                (page === ns && pageType === 'drafts' && isAuthorOrAdmin) ||
                (page === ns && pageType === 'inactive' && isAuthorOrAdmin) ||
                (page === ns && pageType === 'banned' && isAdmin)
            ) ? page : null

        }

        function getDashBoardTitle({ user, post, page }) {

            const isAdmin = ((user && user._status_isFeatured) || (user && user._isEditor))
            const isAuthor = ((user?._id && user._id === post?._author) || (user?._id && user._id === post?._author?._id))
            const isAuthorOrAdmin = (isAdmin || isAuthor)

            if (page === ns && pageType === 'drafts' && isAuthorOrAdmin) {
                return appContext.titles[postContext.name + Ns + 'DraftsTitle']
            }

            if (page === ns && pageType === 'inactive' && isAuthorOrAdmin) {
                return appContext.titles[postContext.name + Ns + 'InactiveTitle']
            }

            return r.getDashBoardTitle({ user, post, page })

        }

        return {
            ...r,
            addMenuItems,
            addContentMenuItems,
            getPageName,
            getDashBoardTitle,
            getFeaturedActions
        }
    },
    adminMenu: function(p) {

        const name = 'job'
        const ns = (name.endsWith('y')) ? name.slice(0, -1) + 'ies' : name + 's'

        const defaultAdminMenu = defaultPostTypeConfig.adminMenu({ ...p, name })
        defaultAdminMenu.order = 20

        const { routes } = p.appContext

        defaultAdminMenu.items = defaultAdminMenu.items.filter((item) => {
            return item.href !== routes[name + 'Route'] + '/new'
        })

        defaultAdminMenu.items.splice(1, 0, ...[
            {
                label: p.appContext.menus[ns + 'LowView'],
                href: routes[ns + 'Route'] + '/lowview'
            },
            {
                label: p.appContext.menus[ns + 'LowEmployees'],
                href: routes[ns + 'Route'] + '/lowemployees'
            },
            {
                label: p.appContext.menus[ns + 'LowEmployeesDSA'],
                href: routes[ns + 'Route'] + '/lowemployeesdsa'
            },
            {
                label: p.appContext.menus[ns + 'NoFormePageview'],
                href: routes[ns + 'Route'] + '/noformepageview'
            }
        ])

        const draftsAdminMenu = defaultPostTypeConfig.adminMenu({ ...p, name: 'draft' })
        draftsAdminMenu.items.splice(1, 1)
        draftsAdminMenu.order = 21

        return [defaultAdminMenu, draftsAdminMenu]
    },
    editorMenu: function(p) {
        const name = 'job'
        const ns = (name.endsWith('y')) ? name.slice(0, -1) + 'ies' : name + 's'

        const defaultAdminMenu = defaultPostTypeConfig.adminMenu({ ...p, name })
        defaultAdminMenu.order = 20

        const { routes } = p.appContext

        defaultAdminMenu.items = defaultAdminMenu.items.filter((item) => {
            return item.href !== routes[name + 'Route'] + '/new'
        })

        defaultAdminMenu.items.splice(1, 0, ...[
            {
                label: p.appContext.menus[ns + 'LowView'],
                href: routes[ns + 'Route'] + '/lowview'
            },
            {
                label: p.appContext.menus[ns + 'LowEmployees'],
                href: routes[ns + 'Route'] + '/lowemployees'
            },
            {
                label: p.appContext.menus[ns + 'LowEmployeesDSA'],
                href: routes[ns + 'Route'] + '/lowemployeesdsa'
            },
            {
                label: p.appContext.menus[ns + 'NoFormePageview'],
                href: routes[ns + 'Route'] + '/noformepageview'
            }
        ])

        const draftsAdminMenu = defaultPostTypeConfig.adminMenu({ ...p, name: 'draft' })
        draftsAdminMenu.items.splice(1, 1)
        draftsAdminMenu.order = 21

        return [defaultAdminMenu, draftsAdminMenu]
    }
}

export default postTypeConfig
